export default "__VITE_ASSET__CqtO_A4s__"